(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('NewsController', NewsInject);

  /** @ngInject */
  function NewsInject(NewsViewModel, newsActions, deviceActions, sessionData, dialogsService, $mdToast, $translate) {
    var vm = this;

    vm.news = new NewsViewModel();
    vm.filterSelected = true;

    init();

    function init(){
      // get wash facilities
      getAllFacilities();

      // get news
      refreshNewsHistory();
    }

    // CHIPS
    vm.querySearch = function(criteria) {
      var cachedQuery = cachedQuery || criteria;
      return cachedQuery ? vm.news.facilities.filter(createFilterFor(cachedQuery)) : [];
    };

    // delete news function
    vm.deleteNews = function(news){
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('DELETE_NEWS_CONFIRMATION'), $translate.instant('DELETE')).then(function(){
        newsActions.deleteNews(news.id).then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('NEWS_DELETE_NOTIFICATION'))
              .position('top right')
              .hideDelay(3000)
          );

          // remove deleted news from table
          var newsId = news.id;

          for(var i=0; i < vm.news.newsData.length; i++){
            if(vm.news.newsData[i].id === newsId){
              vm.news.newsData.splice(i, 1);
            }
          }

        });
      });
    };

    // save news function
    vm.saveNews = function(){
      var data = {
        content : vm.news.newsText,
        title   : vm.news.newsTitle,
        timestamp : vm.news.newsCreated.getTime(),
        language : vm.news.newsLanguage,
        washFacilityIds : parseSelectedFacilities(vm.news.selectedFacilities) || []
      };

      newsActions.saveNews(data).then(function(response){
        // update table data
        data.id = response;
        vm.news.newsData.push(data);

        $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('NEWS_SAVE_NOTIFICATION'))
              .position('bottom right')
              .hideDelay(3000)
          );
      });
    };

    // news table sort
    vm.sortChanged = function(order){
      vm.news.newsSortChanged(order);
      refreshNewsHistory();
    };

    // news pagination
    vm.pageChanged = function(page, limit){
      vm.news.newsPaginationChanged(page, limit);
      refreshNewsHistory()
    };

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(facility) {
        return (angular.lowercase(facility.name).indexOf(lowercaseQuery) != -1);
      };
    }

    function refreshNewsHistory(){
      // get news
      vm.promise = newsActions.getCompanyNews(
          vm.news.newsPage - 1,
          vm.news.newsPageSize,
          vm.news.newsOrderBy,
          vm.news.newsOrder,
          vm.news.companyId
          ).then(function (newsData) {
            vm.news.refreshData(newsData);
          }, function () {
          // todo error handling
      });
    }

    function parseSelectedFacilities(facilities){
      // function that find facility id based on name
      // returns : array of facility ids
      var facilityIds = [];

      for(var i=0; i < facilities.length; i++){
        if(facilities[i].id === -1 ){
          return [];
        }else{
          facilityIds.push(facilities[i].id);
        }
      }
      return facilityIds;
    }

    function getAllFacilities(){
      deviceActions.getAllDevices().then(function(data){
        for(var i=0; i < data.length; i++){
          vm.news.facilities.push({name: data[i].point.name, id: data[i].point.id});
        }
        vm.news.facilities.push({name: $translate.instant('ALL_FACILITIES'), id:-1});
      });
    }

  }
})();
